import { gql } from '@apollo/client';

export * from './confirmEmailChange.mutation.generated';

export const CONFIRM_EMAIL_CHANGE = gql`
  mutation confirmEmailChange($code: String!) {
    confirmEmailChange(input: { code: $code }) {
      success
      errors
    }
  }
`;
